import type { VueCookies } from 'vue-cookies';

import { eventhubClickQueueId, sendEventFunction } from '@/composables/eventHub';
import type { FischerPlugin } from '@/lib/fischerPlugin';
import { readSessionStorage, removeSessionStorage, writeSessionStorage } from '@/lib/safeStorage';

export default async ($fischer: FischerPlugin, $cookies: VueCookies) => {
  const eventQueueJson = readSessionStorage(eventhubClickQueueId);
  if (!eventQueueJson) {
    return;
  }
  let eventQueue;
  try {
    eventQueue = JSON.parse(eventQueueJson);
  } catch (error) {
    console.error(`Could not parse "${eventhubClickQueueId}" from sessionStorage`, error);
    return;
  }

  try {
    while (eventQueue.length) {
      const event = eventQueue.pop();
      await sendEventFunction($fischer, $cookies, 'click', event);
      if (eventQueue.length) {
        writeSessionStorage(eventhubClickQueueId, JSON.stringify(eventQueue));
      }
    }
    removeSessionStorage(eventhubClickQueueId);
  } catch (error) {
    console.error('error processing event queue', error);
  }
};
